import React from 'react'

import styled from 'styled-components'

import { ContentSection, Content } from 'src/refactor/structure'
import {
  ButtonLink,
  Icon,
  mediaQueries,
  palette,
} from '@centivo/react-components'

import src from 'src/assets/logos/vpc/vpc-desktop.png'
import srcMobile from 'src/assets/logos/vpc/vpc-mobile.png'

const ContentWrapper = styled(Content)`
  background-color: ${palette.neutral['grey-f6f7fa']};
  padding-top: 3rem;
  padding-bottom: 2.5rem;

  @media ${mediaQueries.mobile} {
    padding-bottom: 3.75rem;
  }
`

const ContentContainer = styled(ContentSection)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 42rem;

  > img {
    height: 100px;
  }

  > h2 {
    color: ${palette.brand.purple};
    margin: 2.5rem auto 1.5rem;
    font-weight: 700;
    font-size: 1.25rem;
    text-align: center;
  }

  > p {
    text-align: center;
  }

  > ${ButtonLink} {
    background: ${palette.neutral.white};
    margin-top: 2rem;
    padding-right: 3.5rem;
    padding-left: 3.5rem;

    &:hover {
      color: ${palette.brand.pink};
    }

    > svg {
      font-size: 1.25rem;
      text-align: center;
      margin-left: 0.625rem;
    }
  }

  @media ${mediaQueries.mobile} {
    padding: 0 1.25rem;

    > img {
      height: 5rem;
    }
  }
`

export const VPCSection: React.FC = () => (
  <ContentWrapper>
    <ContentContainer>
      <img
        src={src}
        srcSet={`${srcMobile} 212w, ${src} 261w`}
        alt="Centivo virtual primary care"
      />
      <h2>FREE virtual primary care when you need it, where you want it</h2>
      <p>
        Centivo Virtual Primary Care is a convenient alternative to in-person
        primary care. You can visit with your doctor from the comfort of your
        home, at work or on the go – from your phone or computer. If at any time
        you need to be seen in person, your Virtual Primary Care Team will
        coordinate in-person care with a local, in-network provider.
      </p>
      <ButtonLink
        rel="noopener noreferrer"
        buttonType="secondary"
        target="_blank"
        href="https://vpc.centivo.com/"
        edgeType="rounded"
      >
        <span>Learn more</span>
        <Icon icon="external-link" />
      </ButtonLink>
    </ContentContainer>
  </ContentWrapper>
)
